import { render, staticRenderFns } from "./RegionSelectSmall.vue?vue&type=template&id=5cfa6a23&scoped=true&lang=html"
import script from "./RegionSelectSmall.vue?vue&type=script&lang=js"
export * from "./RegionSelectSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfa6a23",
  null
  
)

export default component.exports